import { useSEO } from "@/lib/seo";
import PageHeader from "@/components/sections/PageHeader";
import Specialities from "@/components/sections/Specialities";
import FinalCTA from "@/components/sections/FinalCTA";

export default function ExpertisePage() {
  useSEO({
    title: "Areas of Expertise · Cancer Specialities",
    description:
      "Radiation oncology expertise across breast, gynecological, head and neck, lung, pediatric, neuro, genito-urinary and gastrointestinal cancers.",
    keywords:
      "Breast Cancer Radiation Therapy Hyderabad, Gynecological Cancer Specialist Hyderabad, Head and Neck Cancer Radiation Therapy, Lung Cancer Radiation Hyderabad",
    path: "/expertise",
  });

  return (
    <div data-testid="expertise-page">
      <PageHeader
        eyebrow="Areas of Expertise"
        title="Cancer specialities treated."
        description="Dr. Anusha Mandava's areas of interest and expertise include a wide range of cancers, with a strong focus on precision radiation therapy planning tailored to each patient's condition."
      />
      <Specialities compact />
      <FinalCTA />
    </div>
  );
}
